import { GetApaarUrl, GetUserkycInitiate } from '../../axios/apis/Users';
import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
function MyVerticallyCenteredModal(props) {
    const {img} = props
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" className="fs-6">
          Your Apaar ID
        </Modal.Title>
      </Modal.Header>
       <Modal.Body className="text-center">
        {/* <img  */}
        <iframe
          src={img} 
          alt="Apaar ID"
          style={{ minWidth:"70%", maxWidth: "100%", borderRadius: "8px" }} 
        // width="50%"
          height="300px"  
        ></iframe>

      </Modal.Body>
      <Modal.Footer>
        <Button size="sm" onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

function ApaarButton(props) {
  const {path} = props
  const [modalShow, setModalShow] = React.useState(false);
  const [url , setUrl] = React.useState('')
  const buttonClickHandler = () => {
    GetApaarUrl()
    .then(res=>{
        setUrl(res)
        const isMobile = window.innerWidth <= 768;
        if (isMobile) {
          window.open(res, "_blank");
        } else {
          setModalShow(true)
        }
    })
  }
  const getDigilockerUrl = () => {
    GetUserkycInitiate()
    .then((result)=>{
      if(result.url){
        window.location.href = result.url
      }
    })
  }
  return (
    <>
      <Button variant="primary" disabled={path?(path == 'Not Applicable'?true:false):true}
    //    onClick={() => setModalShow(true)}
       onClick = {path?buttonClickHandler:getDigilockerUrl} 
       >
        {path?"Click Here to View and Copy Your APAAR ID":"Click Here to Authorize APAAR ID"}
      </Button>

      <MyVerticallyCenteredModal
        img={url}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
}

export default ApaarButton